import script from "./base-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-input.vue?vue&type=script&setup=true&lang=ts"

import "./base-input.vue?vue&type=style&index=0&id=1f61adae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f61adae"]])

export default __exports__